import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const T = { royal:"#1263B0", cyan:"#1CBCD3", white:"#fff",
  bg:"#F7F9FC", border:"#E2E8F0", sub:"#94A3B8" };

export default function BottomNav() {
  const { t } = useTranslation();
  const location = useLocation();

  const items = [
    { to:"/dashboard",    icon:"🏠", label:t("dashboard.home") },
    { to:"/dashboard",    icon:"📁", label:t("dashboard.files") },
    { to:"/notifications", icon:"🔔", label:t("dashboard.alerts") },
    { to:"/profil",       icon:"👤", label:t("dashboard.profile") },
  ];

  return (
    <div style={{ position:"fixed", bottom:0, left:0, right:0, zIndex:100,
      background:T.white, borderTop:`1px solid ${T.border}`,
      display:"flex", justifyContent:"space-around",
      padding:"10px 0 14px" }}>
      {items.map((item, i) => {
        const active = location.pathname === item.to;
        return (
          <Link key={i} to={item.to}
            style={{ textDecoration:"none", textAlign:"center",
              display:"flex", flexDirection:"column",
              alignItems:"center", gap:"2px", minWidth:"60px" }}>
            <div style={{ fontSize:"22px",
              filter:active?"none":"grayscale(60%)",
              opacity:active?1:0.6 }}>
              {item.icon}
            </div>
            <span style={{ fontSize:"10px",
              color:active?T.royal:T.sub,
              fontWeight:active?700:400 }}>
              {item.label}
            </span>
          </Link>
        );
      })}
    </div>
  );
}
